import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Tooltip, Text } from 'pcln-design-system'

const AncillaryListItem = styled.li`
  padding-top: 8px;
  display: flex;
  align-items: center;
  line-height: 16px;

  .ancillaryIcon {
    margin-right: 4px;
  }
`

const StyledText = styled(Text.span)`
  text-transform: capitalize;
`

const StyledTooltip = styled(Tooltip)`
  bottom: 2px;
  z-index: 10;
`

export default class AncillaryElement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showTooltip: false,
    }
    this.hideTooltip = this.hideTooltip.bind(this)
    this.showTooltip = this.showTooltip.bind(this)
  }

  hideTooltip() {
    this.setState({
      showTooltip: false,
    })
  }

  showTooltip() {
    this.setState({
      showTooltip: true,
    })
  }

  render() {
    const { type, size, name, iconColor, fontColor, inclusivityText, description } = this.props

    return (
      <AncillaryListItem onMouseOver={() => this.showTooltip(type)} onMouseOut={() => this.hideTooltip(type)}>
        {this.state.showTooltip && (
          <StyledTooltip bg={'background.darkest'} color={'text.lightest'} top center>
            {inclusivityText}
          </StyledTooltip>
        )}
        <Icon
          className='ancillaryIcon'
          data-autobot-element='ancillary-icon'
          size={size}
          name={name}
          color={iconColor}
        />
        <StyledText textTransform='capitalize' fontSize={'12px'} color={fontColor}>
          {description}
        </StyledText>
      </AncillaryListItem>
    )
  }
}

AncillaryElement.propTypes = {
  type: PropTypes.string,
  size: PropTypes.number,
  name: PropTypes.string,
  iconColor: PropTypes.string,
  fontColor: PropTypes.string,
  inclusivityText: PropTypes.string,
  description: PropTypes.string,
}
